<template>
  <!-- 内返设定 -->
  <div class="internalCommission-box">
    <!-- 表格头：按钮组 -->
    <div class="tableBtn-box" :style="version == '0' ? 'visibility:hidden;' : ''">
      <!-- 按钮：添加手数 -->
      <button class="btn btn-style-add" :disabled="!commission.enable || version == '0'" @click="addItem">
        <span class="glyphicon glyphicon-plus"></span>
        {{multiLanguage.btnGroup.addLots}}
      </button>
      <!-- 按钮：删除手数 -->
      <button class="btn btn-style-remove" :disabled="!commission.enable || version == '0'" @click="removeItem">
        <span class="glyphicon glyphicon-trash"></span>
        {{multiLanguage.btnGroup.removeLots}}
      </button>
    </div>
    <!-- 
      因为要做成最左边一列是固定的，所以使用2个表格来拼接显示。
      最左边的列是一个静态的表格，而其他列则是动态的表格
     -->
     <!-- 表格1：固定的列，左浮动-->
    <div class="table-fixed pull-left">
      <table class="table">
        <thead>
          <tr>
            <!-- 
              因为 表格2：滚动列 表头有2行，为了保持水平对齐，固此处加个class:space，写死高度等于 表格2：滚动列 表头2行的高度
             -->
            <th class="space"></th>
          </tr>
        </thead>
        <tbody>
          <!-- 表主体：根据groupSeq循环创建 行 -->
          <tr v-for="groupitem in groupSeq">
            <td class="fixed-td">{{publicLan.products[groupitem]}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 表格2: 可以滚动的列，左浮动 -->
    <div class="table-moveable pull-left">
      <table class="table table-bordered" :class="{'table-striped' : commission.enable && version == '1','disabled': !commission.enable || version == '0'}">
        <thead class="moveable_thead">
          <!-- 表头第一行：只有一列 手数/产品；根据commision.lvl的长度来跨列显示 -->
          <tr><th :colspan="commission.lvl.length">{{multiLanguage.thead.lots}}</th></tr>
          <!-- 表头第二行：根据commission.lvl循环创建 列 -->
          <tr>
            <th v-for="(lvlItem,lvlIndex) in commission.lvl">
              <!-- 列里第一个元素：复选框按钮 -->
              <input type="checkbox" 
                :style="version == '0' ? 'visibility:hidden;' : ''"
                :disabled="!commission.enable || version == '0'"
                :class="{'min-checkbox' : viewBtn == 'double'}"
                :value="lvlIndex" 
                v-model="checkedLvls">
              <!-- 列里第二个元素：如果是第一列，因为要求commission.lvl必须重0.00开始，所以用一个span显示，让其不能编辑就可 -->
              <span v-if="lvlIndex == 0">{{lvlItem.start ? lvlItem.start : '0.00'}}</span>
              <!-- 列里第二个元素：如果不是第一列，，就用一个input显示，让其可以编辑 -->
              <input type="text" v-model="lvlItem.start" v-else
                :disabled="!commission.enable || version == '0'"
                :name="lvlIndex+'_'+'start'"
                :style="errors.has(lvlIndex+'_'+'start') ? 'border-color:#f44336;' : ''"
                v-validate="'required|min_value:0.00|decimal:2'">
              <!-- 列里第三个元素：分隔符 '-' -->
              <span>-</span>
              <!-- 列里第四个元素：同第二个元素一样，最后一列必须是不能编辑的，强制显示"无限" -->
              <span v-if="lvlIndex == commission.lvl.length-1">{{multiLanguage.infinite}}</span>
              <!-- 列里第四个元素：如果不是最后一列，就可以编辑，所以用input -->
              <input type="text" v-model="lvlItem.end" v-else
                :disabled="!commission.enable || version == '0'"
                :name="lvlIndex+'_'+'end'"
                :style="errors.has(lvlIndex+'_'+'end') ? 'border-color:#f44336;' : ''"
                v-validate="'required|min_value:0.00|decimal:2'">
              <!-- 列里最后一个元素：单位 "Lots" -->
              <span>Lots</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- 表主体：根据groupSeq循环创建 行 -->
          <tr v-for="(groupitem,groupIndex) in groupSeq">
            <!-- 每行：根据commission.lvl的长度循环创建 列 -->
            <td v-for="(lvlItem,lvlIndex) in commission.lvl">
              <!-- 每列第一个元素：input -->
              <input type="text" v-model="lvlItem[groupitem]" 
                :disabled="!commission.enable || version == '0'"
                :name="lvlIndex+'_'+groupitem"
                :style="errors.has(lvlIndex+'_'+groupitem) ? 'border-color:#f44336;' : ''"
                v-validate="'required|min_value:0.00|decimal:2'">
              <!-- 每列第二个元素：单位 “USD” -->
              <span></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 清除浮动 -->
    <div class="clear"></div>
  </div>
</template>

<script>
export default {
  mixins: [ require("common/mixin/base.js").base({publicLan:"publicLan"}) ],
  props: {
    multiLanguage: { // 多语言
      type: Object,
      default: {},
    },
    commission: { // 佣金数据
      type: Object,
      default: {},
    },
    groupSeq: { // 产品组
      type: Array,
      default: [],
    },
    version: { // 当前版本：0为审核的版本，1为未审核的版本
      type: String,
      default: ''
    },
    viewBtn: { // 浏览的视图： double为对比浏览，onlyOne为单页浏览
      type: String,
      default: ''
    }
  },
  data () {
    return {
      checkedLvls: [], // 已经选中的commission.lvl的下标，存放在这个数组里面，方便添加或者删除 lvl 时使用
    }
  },
  methods: {
    addItem () { // 添加lvl的方法
      /* 条件：
        * 1、最多只能添加4个级别，
        * 2、可以在指定的位置添加级别
        * 3、如果没有选中位置，则默认在最后添加级别 */
      if (this.checkedLvls.length > 0 && this.commission.lvl.length + this.checkedLvls.length <= 4) { 
        this.checkedLvls.forEach(el => {
          let tem = {}
          let keys = Object.keys(this.commission.lvl[el])
          keys.forEach(item => { tem[item] = '' })
          this.commission.lvl.splice(el+1,0,tem)
        })
        this.checkedLvls = []
      }
      else if (this.checkedLvls.length == 0 && this.commission.lvl.length + this.checkedLvls.length < 4) {
        let tem = {}
        let keys = Object.keys(this.commission.lvl[0])
        keys.forEach(item => { tem[item] = '' })
        this.commission.lvl.push(tem)
      }
      else return
    },
    removeItem () { // 删除lvl的方法
      /* 条件：
      * 1、必须选中才能删除，且删除前需要确认
      * 2、最少保留一个级别
      * 3、删除可以指定的级别
      * */
     if (this.checkedLvls.length > 0) {
       let msg = this.multiLanguage.btnGroup.confirmDeleteText
        if (confirm(msg) == true) {
          if (this.commission.lvl.length - this.checkedLvls.length >= 1) {
            let tem = this.commission.lvl.concat([])
            this.checkedLvls.forEach(item => {
              delete tem[item]
            })
            this.commission.lvl = tem.filter(item => item != null)
            this.checkedLvls = []
          }
          else return
        }
     }
     else return
    },
  },
}
</script>

<style lang="scss" scoped>
  .internalCommission-box{
    .tableBtn-box{
      text-align: right;
      margin-bottom: 10px;
      button{
        border-radius: 3px;
        span{
          font-size: 12px;
        }
      }
    }
    table{
      text-align: center;
      thead th {
        text-align: center;
        position: relative;
        span{
          display: inline-block;
          height: 31px;
          line-height: 31px;
        }
      }
      input[type='text']{
        text-align: center;
        max-width: 50px;
        height: 30px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin: 0 5px;
        background-color: transparent;
      }
      input[type='checkbox']{
        position: absolute;
        top: 0;
        left: 0px;
        vertical-align: middle;
        margin-top: 0;
        width: 22px;
        height: 22px;
      }
      .min-checkbox{
        width: 15px!important;
        height: 15px!important;
      }
    }
    .table-fixed{
      background: #EBEDF7;
      border-top: 1px solid #bbb;
      border-left: 1px solid #bbb;
      border-bottom: 1px solid #bbb;
      width: 15%;
      table{
        color: #3F51B5;
        font-weight: 700;
        thead{
          .space{
            height: 100px;
          }
        }
        .fixed-td{
            height: 55px;
          }
      }
    }
    .table-moveable{
      width: 85%;
      white-space: nowrap;
      overflow-x: auto;
    }
    .btn-style-add {
      background-color: #3f51b5;
      color:#fff;
    }
    .btn-style-remove {
      background-color:#f08712;
      color:#fff;
    }
    .table > thead > tr > th, .table > tbody > tr > th, .table > tfoot > tr > th, .table > thead > tr > td, .table > tbody > tr > td, .table > tfoot > tr > td{
      padding: 12px 0;
    }
  }
</style>





// WEBPACK FOOTER //
// internalCommission.vue?575312fc